import type { ParametrosAplicativoModel } from "../models/parametrosAplicativoModel"

export enum ParametrosAplicativoActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type ParametrosAplicativoActionModel =
    | {
          type: ParametrosAplicativoActionsTypes.CARREGAR
          payload: ParametrosAplicativoModel
      }
    | {
          type: ParametrosAplicativoActionsTypes.ATUALIZAR_CAMPO
          payload: {
              campo: keyof ParametrosAplicativoModel
              valor: string | number | boolean | null
          }
      }
    | { type: ParametrosAplicativoActionsTypes.RESETAR }
